import styled from 'styled-components';

// Props para permitir variar a cor conforme o className em index.css
export const Spinner = styled.div.attrs((props) => ({
    className: `lds-dual-ring ${props.className || ''}`,
}))``;
